module.exports = __webpack_public_path__ + "images/emails/i-1-d0244443.gif";